module.exports = __webpack_public_path__ + "static/media/back2.6087df5f.jpg";